import { DescriptionRequestOptionsSelected } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'
import SynopticTemplatesModal from '@/modules/diagnosisModule/views/form/modals/SynopticTemplatesModal.vue'
import { TemplateRequestApplied, UpdatedSynopticTemplate } from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor-action-synoptic-templates/preformatted-editor-action-synoptic-templates.model'
import { DescriptionResponseEditor } from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor/preformatted-editor.model'

@Component({
    components: {
        SynopticTemplatesModal
    }
})
export default class PreformattedEditorActionSynopticTemplates extends Vue {
    @Prop() readonly description!: DescriptionResponseEditor
    @Prop() readonly laboratoryId!: number
    @Ref() readonly synopticTemplatesModal!: any
    @Emit()
    update(updatedTemplate: TemplateRequestApplied): TemplateRequestApplied {
        return updatedTemplate
    }

    get templateId(): number {
        return this.description.template?.id!
    }

    get optionsSelected(): DescriptionRequestOptionsSelected {
        return this.description.optionsSelected
    }

    applyTemplateChange(templateApplied: UpdatedSynopticTemplate): void {
        const updatedTemplate: TemplateRequestApplied = {
            text: templateApplied.text,
            descriptionType: templateApplied?.descriptionType,
            originalConcurrencyUpdatedAt: this.description.originalConcurrencyUpdatedAt,
            optionsSelected: templateApplied.optionsSelected,
            templateId: templateApplied.templateId,
            title: templateApplied.title,
            textEditingAllowed: templateApplied.textEditingAllowed
        }
        this.update(updatedTemplate)
    }

    showTemplatesModal(loadCurrentTemplateDetails: boolean = false): void {
        this.synopticTemplatesModal.show(loadCurrentTemplateDetails)
    }

    async openAssociatedImagesModalSingleSelection(): Promise<void> {
        await this.showModalAdviceWhenDelete()
    }

    private async showModalAdviceWhenDelete(textModal: string = this.$tc('configuration.modal.preformated.showAdviceAttachments')): Promise<void> {
        return this.$_showWarningModal(textModal)
    }
}
